import { BehaviorSubject, Subscription, Observable } from 'rxjs';

export interface Ring<D> {
   input: BehaviorSubject<D>;
   output: BehaviorSubject<D>;
   subscribe(): Subscription;
}


export interface ChainArgs<D> {
   isAlive: Observable<boolean>,
   source: Observable<D[]>,
   rings: Ring<D[]>[]
}

export class Chain<D> {
   private readonly subscriptions: Subscription[] = [];
   private readonly initiator = new BehaviorSubject<D[]>([]);
   private readonly rings: Ring<D[]>[];
   private readonly source: Observable<D[]>;

   constructor({ isAlive, source, rings }: ChainArgs<D>) {
      this.rings = rings;
      this.source = source;
      isAlive.subscribe(isAlive => {
         if (isAlive) {
            this.init();
         } else {
            this.destroy();
         }
      });
   }


   private init() {
      let input = this.initiator;

      for (const ring of this.rings) {
         ring.input = input;
         this.subscriptions.push(ring.subscribe());
         input = ring.output;
      }

      this.subscriptions.push(this.source.subscribe(data => {
         this.initiator.next(data);
      }));
   }


   private destroy() {
      for (const subscription of this.subscriptions) {
         subscription.unsubscribe();
      }
   }
}